// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2QtEP","inputDescription":"styles_inputDescription__2COub"};